/* Coverage:
 Statements: 0%
 Branches: 0%
 Functions: 0%
 (Generated by scripts/generate-coverage-comments.js - Do not edit this comment)
*/
import { useActionData, useNavigation } from 'react-router';
import { useEffect } from 'react'
import { toast } from '~/components/Toast'
interface ActionResponse {
  success?: boolean
  error?: string
}
interface ActionToastsProps {
  successMessage?: string
  /** Optional description of the action for screen readers */
  actionDescription?: string
}
export function ActionToasts({ successMessage, actionDescription = 'Action' }: ActionToastsProps) {
  const actionData = useActionData<ActionResponse>()
  const navigation = useNavigation()
  useEffect(() => {
    if (navigation.state === 'idle') {
      if (actionData?.error) {
        toast({
          type: 'error',
          content: actionData.error,
          role: 'alert',
          'aria-live': 'assertive',
          'aria-label': `${actionDescription} failed: ${actionData.error}`,
        })
      }
      if (actionData?.success && successMessage) {
        toast({
          type: 'success',
          content: successMessage,
          role: 'status',
          'aria-live': 'polite',
          'aria-label': `${actionDescription} successful: ${successMessage}`,
        })
      }
    }
  }, [actionData, navigation.state, successMessage, actionDescription])
  return null
}
